import Layout from "@/views/main/Main.vue";
import type { RouteRecordRaw } from "vue-router";
const blackWarehouseRouter: RouteRecordRaw = {
  path: "/blackWarehouse",
  component: Layout,
  redirect: "noredirect",
  meta: {
    icon: "el-icon-tickets",
    title: "单据出库"
  },
  children: [
    {
      path: '/blackWarehouse/inventoryLists',
      component: () => import("@/views/main/blackWarehouse/inventoryLists/inventoryLists.vue"),
      name: 'inventoryLists',
      meta: {
        title: '库存列表'
      }
    },
    {
      path: '/blackWarehouse/inventoryListsCx',
      component: () => import("@/views/main/blackWarehouse/inventoryListsCx/inventoryListsCx.vue"),
      name: 'inventoryListsCx',
      meta: {
        title: '库存列表(查询)'
      }
    },
    {
      path: '/blackWarehouse/materialMessage',
      component: () => import("@/views/main/blackWarehouse/materialMessage/materialMessage.vue"),
      name: 'materialMessage',
      meta: {
        title: '物料管理'
      }
    },
    {
      path: '/blackWarehouse/allocateOrderBlack',
      component: () => import("@/views/main/blackWarehouse/allocateOrderBlack/allocateOrderBlack.vue"),
      name: 'allocateOrderBlack',
      meta: {
        title: '黑库单据调拨'
      }
    },
    {
      path: '/blackWarehouse/allocateOrderBlackDy',
      component: () => import("@/views/main/blackWarehouse/allocateOrderBlackDy/allocateOrderBlackDy.vue"),
      name: 'allocateOrderBlackDy',
      meta: {
        title: '黑库单据调拨(打印)'
      }
    },
    {
      path: '/blackWarehouse/wareTagPrin',
      component: () => import("@/views/main/blackWarehouse/wareTagPrin/wareTagPrin.vue"),
      name: 'wareTagPrin',
      meta: {
        title: '物料标签打印'
      }
    },
   
		
  ]
};

//单据管理
export default blackWarehouseRouter;